import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaExclamationTriangle, FaArrowLeft, FaHome } from 'react-icons/fa';

const UnauthorizedPage = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    // Use a safe redirect based on the user's current role
    const handleSafeRedirect = () => {
        if (user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") {
            navigate("/smartcity/admin/dashboard", { replace: true });
        } else {
            navigate("/smartcity/dashboard", { replace: true });
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-5 font-sans">
            <div className="text-center max-w-md w-full bg-white p-10 rounded-2xl shadow-xl border-t-4 border-[#c99432]">
                
                {/* Visual Icon */}
                <div className="flex justify-center mb-6">
                    <div className="bg-orange-100 p-4 rounded-full">
                        <FaExclamationTriangle className="text-[#c99432] text-5xl" />
                    </div>
                </div>

                {/* Error Text */}
                <h1 className="text-6xl font-extrabold text-gray-900 mb-2">404</h1>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Page Not Available</h2>
                <p className="text-gray-600 mb-8">
                    Oops! The page you are looking for doesn't exist or you don't have the required permissions to view it.
                </p>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center gap-2 px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-all font-medium"
                    >
                        <FaArrowLeft /> Go Back
                    </button>
                </div>

                {/* Branding Footer */}
                <div className="mt-10 pt-6 border-t border-gray-100">
                    <p className="text-sm text-gray-400 uppercase tracking-widest font-bold">
                        Smart City
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UnauthorizedPage;